let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8aJvm")).then(() => parcelRequire('b3AyE'));